import React from 'react';
import NewBMStep7 from './NewBMStep7';

const NewBMStep7Container = ({ serverSizesData = [], formikProp = {}, regionsData = [] }) => {
  return <NewBMStep7 serverSizesData={serverSizesData} formikProp={formikProp} regionsData={regionsData} />;
};

export default NewBMStep7Container;
